export default "__VITE_ASSET__5ac65f85__"